'use client';
import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const SocialIcon = ({ Icon }: { Icon: any }) => (
    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[var(--primary-color)]">
        <Icon className="w-4 h-4" />
    </div>
);

const Footer = () => {
    return (
        <footer className="bg-[#052c65] text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto container-padding">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-6">About JIL</h3>
                        <p className="text-gray-300 mb-6">
                            Your trusted partner in global logistics solutions. We provide efficient and reliable shipping services worldwide.
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                                <SocialIcon Icon={FaFacebookF} />
                            </a>
                            <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                                <SocialIcon Icon={FaTwitter} />
                            </a>
                            <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                                <SocialIcon Icon={FaLinkedinIn} />
                            </a>
                            <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                                <SocialIcon Icon={FaInstagram} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-6">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about" className="text-gray-300 hover:text-white transition duration-300">
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-gray-300 hover:text-white transition duration-300">
                                    Our Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-300 hover:text-white transition duration-300">
                                    Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition duration-300">
                                    Privacy Policy
                                </Link>
                            </li>
                            {/* <li>
                                <Link to="/terms" className="text-[var(--text-secondary)] hover:text-white transition duration-300">
                                    Terms & Conditions
                                </Link>
                            </li> */}
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-xl font-bold mb-6">Our Services</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/services#drayage" className="text-gray-300 hover:text-white transition duration-300">
                                    National Drayage
                                </Link>
                            </li>
                            <li>
                                <Link to="/services#transloading" className="text-gray-300 hover:text-white transition duration-300">
                                    Transloading
                                </Link>
                            </li>
                            <li>
                                <Link to="/services#warehousing" className="text-gray-300 hover:text-white transition duration-300">
                                    Warehousing
                                </Link>
                            </li>
                            <li>
                                <Link to="/services#ftl" className="text-gray-300 hover:text-white transition duration-300">
                                    Domestic FTL
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-6">Contact Info</h3>
                        <ul className="space-y-4">
                            <li className="flex items-start space-x-3">
                                <MapPinIcon className="w-6 h-6 text-[var(--primary-color)] flex-shrink-0" />
                                <span className="text-gray-300">
                                    100 W Victoria St Long Beach,
                                    <br />
                                    CA 90805 USA
                                </span>
                            </li>
                            <li className="flex items-center space-x-3">
                                <PhoneIcon className="w-6 h-6 text-[var(--primary-color)] flex-shrink-0" />
                                <span className="text-gray-300">(562) 618-4677</span>
                            </li>
                            <li className="flex items-center space-x-3">
                                <EnvelopeIcon className="w-6 h-6 text-[var(--primary-color)] flex-shrink-0" />
                                <span className="text-gray-300">cs@junctionil.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-white/10">
                    <div className="text-center text-gray-300">
                        <p>&copy; {new Date().getFullYear()} Junction Integrated Logistics. All rights reserved. Developed by <a href="https://trikaiser.com" target="_blank" rel="noopener noreferrer" className="text-[var(--primary-color)] hover:text-[var(--background-dark)] transition duration-300">Trikaiser LLC</a></p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
